import axios from 'axios';
export default (providerId, patientProfileId, dueDateTime, duration, organizationId) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .post(process.env.VUE_APP_GATEWAY_ENDPOINT + 'v3/users/checkout', {
        organization_id: organizationId || 9999, // 9999 is B2C
        location_id: 0, // online
        promotion_token: '',
        provider_profile_id: providerId,
        patient_profile_id: patientProfileId,
        reserved_duration: duration,
        due: dueDateTime,
      })
      .then((data) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
